const initialState = {
    archived: [],
    isReading: false,
    counts: {
        archived_count: 0,
        total_archived_count: 0,
        total_count: 0
    },
    archiveUsers: [],
    isReadingArchiveUsers: false,
}

export default initialState;
